import React from 'react';
import PropTypes from 'prop-types';

const Config = React.createContext();

const ConfigProvider = ({ config, children }) => (
    <Config.Provider value={config}>
        {children}
    </Config.Provider>
);
ConfigProvider.propTypes = {
    config: PropTypes.any,
    children: PropTypes.any,
};

export {
    ConfigProvider,
    Config,
};
